<template>
    <servicesTopComponent/>
    <ServicesComponent/>
</template>

<script setup>
    import servicesTopComponent from '@/components/services/ServicesTopComponent.vue';
    import ServicesComponent from '@/components/services/ServicesComponent.vue';
    import { setPageData } from '@/functions/general';
    import { onMounted } from 'vue';
    onMounted(() => {
        setPageData({
            title: 'Pelayanan Kesehatan Kami',
            description: 'Rumah Sakit Melinda 2 selalu meningkatkan kualitas pelayanan yang terbaik untuk masyarakat. Kami memberikan banyak layanan kesehatan yang bisa digunakan oleh pasien diantaranya IGD 24 jam dengan penanganan dokter umum dan dokter spesialis.'
        });
    });
    scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>
